import { useMemo, useState } from "react"
import {
  MaterialReactTable,
  // createRow,
  useMaterialReactTable,
} from "material-react-table"
import DetalleImpresion from "../../Zonas/components/DetalleImpresion"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import { createTheme, ThemeProvider, useTheme, Box, Button, IconButton, Tooltip } from "@mui/material"
import { esES } from "@mui/material/locale"
import ImprimirIcon from "../../../assets/iconos/Impresion.ico"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import EditIcon from "@mui/icons-material/Edit"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import DeleteIcon from "@mui/icons-material/Delete"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useNavigate } from "react-router-dom"
import CrearIcon from "../../../assets/iconos/Crear.ico"
import TonosPdf from "./TonosPdf"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"

const CustomTable = () => {
  // para movernos a crear y editar
  const navigate = useNavigate()
  const columns = useMemo(
    () => [
      {
        accessorKey: "toncodigo",
        header: "Código",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "tondescripcion",
        header: "Descripción",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "tonstatus",
        header: "Estado",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          let cellValue = cell.getValue()
          if (cellValue === "A") {
            cellValue = "ACTIVO"
          } else {
            cellValue = "INACTIVO"
          }
          return cellValue
        },
      },
      {
        accessorKey: "tonusuisys",
        header: "Usuario Creacion",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "tonfecisys",
        header: "Fecha de Creación",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
      },
      {
        accessorKey: "tonhorisys",
        header: "Hora de Creación",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return new Date(cellValue).toLocaleTimeString()
        },
      },
      {
        accessorKey: "tonusumsys",
        header: "Usuario Modifica",
        enableEditing: false,
        size: 80,
      },
      {
        accessorKey: "tonfecmsys",
        header: "Fecha Modifica",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
      },
      {
        accessorKey: "tonhormsys",
        header: "Hora Modifica",
        enableEditing: false,
        size: 80,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return new Date(cellValue).toLocaleTimeString()
        },
      },
    ],
    [],
  )

  const { mutateAsync: createTonos, isPending: isCreatingTonos } = useCreateTonos()

  const {
    data: fetchedTonos = [],
    isError: isLoadingTonosError,
    isFetching: isFetchingTonos,
    isLoading: isLoadingTonos,
  } = useGetTonos()
  // useUpdateZona() hook de update, ,updateZona funcion que se ejecuta
  const { mutateAsync: updateTono, isPending: isUpdatingTono } = useUpdateTono()
  // useDeleteZona() hook de delete , usa la funcion deleteZona()
  const { mutateAsync: deleteTono, isPending: isDeletingTono } = useDeleteTono()
  // funcion que muestra el modal de eliminacion
  const openDeleteConfirmModal = async (row) => {
    if (window.confirm("¿Está seguro que quiere eliminar este tono?")) {
      await deleteTono(row.original.toncodigo)
    }
  }
  const table = useMaterialReactTable({
    columns,
    data: fetchedTonos,
    enableEditing: true,
    initialState: {
      showColumnFilters: true,
    },
    enableRowActions: true,
    localization: { ...MRT_Localization_ES },
    getRowId: (row) => row.poscodigo,
    // si se cargar el error al importar los datos
    muiToolbarAlertBannerProps: isLoadingTonosError
      ? {
          color: "error",
          children: "Error en cargar los tonos",
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Editar">
          <IconButton
            onClick={() => {
              navigate(`editar/${row?.original.toncodigo}`, {
                state: row?.original,
              })
            }}
          >
            <img src={DetalleIcon} alt="Editar" style={{ width: "20px" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <img src={EliminarIcon} alt="Grabar" style={{ width: "20px" }} />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    state: {
      isLoading: isLoadingTonos,
      isSaving: isCreatingTonos || isUpdatingTono || isDeletingTono,
      showAlertBanner: isLoadingTonos,
      showProgressBars: isFetchingTonos,
    },
  })
  return (
    <>
      <MaterialReactTable table={table} />
      <CustomBackdrop isLoading={table.getState().isSaving} />
    </>
  )
}
function useGetTonos() {
  return useQuery({
    queryKey: ["Tonos"],
    queryFn: async () => {
      // send api request here
      let response = await fetchwrapper("/Tonos/getTonos")
      response = await response.json()
      response = response?.data
      console.log("data fetched", response)
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return response
    },
    refetchOnWindowFocus: false,
  })
}

// hooks a los que se les asigna una api y se encargan de actualizar el estado del componente
function useCreateTonos() {
  // hook para crear la zona
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (tono) => {
      await new Promise((resolve) => setTimeout(resolve, 1000)) // fake api call
      return Promise.resolve()
    },
    onMutate: (newTono) => {
      queryClient.setQueryData(["Tonos"], (prevTonos) =>
        prevTonos?.map((prevTonos) => (prevTonos.toncodigo === newTono.toncodigo ? newTono : prevTonos)),
      )
    },
  })
}
function useUpdateTono() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (tono) => {
      // send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)) // fake api call
      return Promise.resolve()
    },
    // client side optimistic update
    onMutate: (newTonoInfo) => {
      queryClient.setQueryData(["Tonos"], (prevTonos) =>
        prevTonos?.map((prevTonos) => (prevTonos.poscodigo === newTonoInfo.poscodigo ? newTonoInfo : prevTonos)),
      )
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['bancoDePreguntas'] }), //refetch bancoDePreguntas after mutation, disabled for demo
  })
}
function useDeleteTono() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (codigoTono) => {
      const options = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }

      const response = await fetchwrapper(`/Tonos/deleteTono/${codigoTono}`, options)
      return response
    },
    // actualizacion optimista
    onMutate: (codigoTono) => {
      queryClient.setQueryData(["Tonos"], (prevTonos) => prevTonos?.filter((tono) => tono.toncodigo !== codigoTono))
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["Tonos"] })
    },
    onSuccess: () => {
      alert("Tono eliminado con exito")
    },
    onError: () => {
      alert("No se pudo eliminar el tono")
    },
  })
}

const DataGridTonos = () => {
  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])
  const {
    data: fetchedTonos = [],
    isError: isLoadingTonosError,
    isFetching: isFetchingTonos,
    isLoading: isLoadingTonos,
  } = useGetTonos()
  const handleOpenModal = () => {
    setInfoGenerada(fetchedTonos) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }
  console.log("info pdf", fetchedTonos)
  const handleCloseModal = () => {
    setOpenModal(false)
    navigate("/home/dashboard/Tonos")
  }
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <div>
      <Tooltip title="Crear Tono">
        <Button color="primary" onClick={() => navigate("crear")} sx={{ marginBottom: "15px" }}>
          <img src={CrearIcon} alt="Crear" style={{ width: "30px" }} />
        </Button>
      </Tooltip>
      <Tooltip title="Imprimir">
        <Button color="primary" onClick={handleOpenModal} sx={{ marginBottom: "15px" }}>
          <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
        </Button>
      </Tooltip>
      <DetalleImpresion
        open={openModal}
        handleClose={handleCloseModal}
        infoGenerada={fetchedTonos}
        nombrePdf={"Tonos"}
        PdfComponent={TonosPdf}
      />
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable />
      </ThemeProvider>
    </div>
  )
}
export default DataGridTonos
